// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3TeO4","header":"ClearentDisclaimer_header__308M3","inner":"ClearentDisclaimer_inner__3Toqt"};